<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>{{ menu ? menu.name : 'Loading...' }}</h1>
      </b-col>
      <b-col class="text-right px-sm-3 px-0">
        <b-button
          variant="primary"
          @click="$router.push('/organization-menus')"
        >
          Back
        </b-button>
      </b-col>
    </b-row>

    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          small
          :fields="fields"
          :items="menuItems"
          :busy="loading"
        >
          <template #cell(name)="row">
            {{ row.item.name ? row.item.name : '-' }}
          </template>
          <template #cell(price)="row">
            {{ row.item.price ? `$${row.item.price}` : '-' }}
          </template>
          <template #cell(status)="row">
            <b-form-checkbox
              :checked="row.item.status === 'active'"
              :disabled="togglingItems[row.item.import_key]"
              class="status-checkbox"
              @change="toggleItemStatus(row.item)"
            >
              {{ row.item.status === 'active' ? 'Active' : 'Inactive' }}
            </b-form-checkbox>
          </template>
          <template #cell(import_key)="row">
            {{ row.item.import_key ? row.item.import_key : '-' }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import OrganizationMenusAPI from '../../services/OrganizationMenusAPI';

export default {
  name: 'OrganizationMenu',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      menu: null,
      togglingItems: {},
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: false,
        },
        {
          key: 'price',
          label: 'Price',
          sortable: false,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false,
          thStyle: { width: '120px' },
          tdClass: 'status-cell',
        },
        {
          key: 'import_key',
          label: 'Import Key',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', ['organizationAdmin', 'organizationIds']),
    currentOrganizationId() {
      return this.organizationIds.length > 0 ? this.organizationIds[0] : null;
    },
    menuItems() {
      return this.menu && this.menu.menu_items ? this.menu.menu_items : [];
    },
  },
  created() {
    if (!this.organizationAdmin) {
      this.$router.push('/');
      return;
    }
    this.loadMenu();
  },
  methods: {
    loadMenu() {
      if (!this.currentOrganizationId) {
        return;
      }

      this.loading = true;

      OrganizationMenusAPI.getMenu(this.currentOrganizationId, this.id, {
        with: 'menuItems.item',
      })
        .then((data) => {
          this.menu = data.data || data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          alert(error);
        });
    },
    toggleItemStatus(item) {
      const newStatus = item.status === 'active' ? 'inactive' : 'active';
      const importKey = item.import_key;

      this.$set(this.togglingItems, importKey, true);

      OrganizationMenusAPI.toggleItem(
        this.currentOrganizationId,
        this.id,
        importKey,
        newStatus
      )
        .then(() => {
          item.status = newStatus;
          this.$set(this.togglingItems, importKey, false);
        })
        .catch((error) => {
          this.$set(this.togglingItems, importKey, false);
          alert(error);
        });
    },
  },
};
</script>

<style scoped>
.status-checkbox {
  cursor: pointer;
}

.status-checkbox >>> .custom-control-label {
  cursor: pointer;
}
</style>
